<template>
  <div v-if="cart && cart.length">
    <button @click="open= !open" class="border-top border-bottom text-left d-block d-lg-none py-3 order-summary-sm">
      <b-container class="d-flex flex-row align-items-center order-summary-dropdown">
        <font-awesome-icon :icon="['fas', 'shopping-cart']" class="mx-2 ml-sm-0 footer_btn"></font-awesome-icon>
        <template v-if="open">
          <span>Hide order summary</span>
          <font-awesome-icon class="ml-2"  :icon="['fas', 'angle-up']"></font-awesome-icon>
        </template>
        <template v-else>
          <span>Show order summary</span>
          <font-awesome-icon class="ml-2 mt-1 fa-w-12"  :icon="['fas', 'angle-down']"></font-awesome-icon>
        </template>
      </b-container>
    </button>
    <transition name="slide-fade">
      <div class="d-block d-lg-none order-summary-sm">
        <b-container>
          <div class="checkout-order-summary" :class="{'py-2': open, 'py-1': open}">
            <template v-if="open">
              <div class="order-summary-height">
                <table class="border-bottom my-0 mx-3 mx-sm-0">
                  <tr class="border-bottom" v-for="(item, index) in updatedCart" :key="'ct-' + index.toString()">
                    <td>
                      <img class="my-3 product-img" :src="getImageUrl(item)" @error="setAltImg($event, item)" alt=""/>
                    </td>
                    <td class="cart-product-name-cell w-100 pl-3">
                      <div class="mt-3">
                        <div class="d-flex justify-content-between">
                          <span class="checkout-product-name" v-html="item.campaign_product.name"></span>
                          <div type="button" v-b-tooltip.hover title="Remove product from cart">
                            <font-awesome-icon class="mt-1" :style="{ color: 'rgb(255 63 63)' }"
                                               :icon="['fas', 'trash-alt']"
                                               @click="updateQuantity(index, 0, false)"
                            >
                            </font-awesome-icon>
                          </div>
                        </div>
                        <div v-if="item.variant" class="product-variants">
                          {{ getItemVariants(item) }}
                        </div>
                        <div class="cart-product-name-text">Qty: {{item.quantity}}</div>
                      </div>
                      <div class="quantity-toggle mt-2" :class="{'my-3': item.quantity < item.campaign_product.max_quantity}">
                        <div class="cart-quantity-wrapper">
                          <button :disabled="item.quantity === 1 || item.campaign_product.max_quantity === 1" class="cart-quantity-button" @click="updateQuantity(index, item.quantity-1, false)">&mdash;</button>
                          <input class="cart-quantity-input" type="number" min="1" :max="item.campaign_product.max_quantity || 10" :value="item.quantity"
                                 v-on:input="updateQuantity(index, $event)" @change="debounceCartUpdate"
                                 :disabled="item.campaign_product.max_quantity === 1"
                          />
                          <button :disabled="item.quantity === item.campaign_product.max_quantity" class="cart-quantity-button" @click="updateQuantity(index, item.quantity+1, false)">&#xff0b;</button>
                        </div>
                        <div class="mt-auto ml-auto order-price"><strong>{{getPrice(item) | currency(currency)}}</strong></div>
                      </div>
                      <p v-if="item.quantity >= item.campaign_product.max_quantity" class="max-quantity mb-2">
                        <sup>*</sup>Maximum order limit of {{item.campaign_product.max_quantity}}
                      </p>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="mt-4 mx-3 mx-sm-0 d-flex justify-content-between">
                <div>Subtotal</div>
                <div>{{totalPrice | currency(currency)}}</div>
              </div>
              <div class="mt-1 mx-3 mx-sm-0 d-flex justify-content-between">
                <div>Shipping fees</div>
                <div v-if="shipping && shipping.length && Number(shipping[0].price) > 0">{{shipping[0].price | currency(currency)}}</div>
                <div v-else>Free</div>
              </div>
              <div class="mt-1 mx-3 mx-sm-0 border-bottom d-flex justify-content-between">
                <div class="mb-3">Taxes</div>
                <div>{{tax | currency(currency)}}</div>
              </div>
            </template>
            <div class="p-3 px-sm-0 d-flex justify-content-between">
              <div><strong class="text-nowrap grand-total">Grand Total</strong> (including tax)</div>
              <div class="text-right"><strong class="grand-total">{{totalPriceIncTax | currency(currency)}}</strong></div>
            </div>
          </div>
        </b-container>
      </div>
    </transition>
    <div class="mt-2 mt-sm-4">
      <b-row class="">
        <b-col lg="6" cols="12">
          <b-form @submit.prevent="checkout()">
            <div class="checkout-card">
              <div class="shadow-sm p-3 bg-white rounded d-flex justify-content-between align-items-center">
                <p class="mb-0 card-heading">BILLING INFORMATION</p>
                <template v-if="isSessionUserKnown">
                  <a v-if="showBillEdit" class="checkout-change-button" @click="toggleEditing('bill')">Save</a>
                  <a v-else class="checkout-change-button" @click="toggleEditing('bill')">Edit</a>
                </template>
              </div>
              <div class="p-3" v-if="isSessionUserKnown && !showBillEdit">
                <div class="checkout-address-container">
                  <p class="checkout-text">{{customer.first_name}} {{customer.last_name}}
                  </p>
                  <p class="checkout-text mt-1">{{customer.address1}}</p>
                  <p class="checkout-text mt-1">{{customer.address2}}</p>
                  <p class="checkout-text mt-1">
                    {{customer.city + ', '}}{{customer.state + ', '}}
                    {{customer.country + ', '}}{{customer.zip}}</p>
                  <p class="checkout-text mt-1">{{customer.email}}</p>
                  <p class="checkout-text mt-1">{{customer.phone}}</p>s
                </div>
              </div>
              <div class="p-3" v-if="showBillEdit">
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <label for="first_name" v-if="isIE">First Name</label>
                    <b-form-group label="" label-for="first_name">
                      <div data-for="first_name" class="placeholder-label">First Name</div>
                      <b-form-input id="first_name" type="text" v-model.trim="customer.first_name" placeholder="First Name"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.first_name" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.first_name }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="last_name" v-if="isIE">Last Name</label>
                    <b-form-group label="" label-for="last_name">
                      <div data-for="last_name" class="placeholder-label">Last Name</div>
                      <b-form-input id="last_name" type="text" v-model.trim="customer.last_name" placeholder="Last Name"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.last_name" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.last_name }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="isFieldRequired('company')">
                  <b-col class="col-pd">
                    <label for="company" v-if="isIE">{{getFieldLabel('company', 'Company')}}</label>
                    <b-form-group label="" label-for="company">
                      <div data-for="company" class="placeholder-label">{{getFieldLabel('company', 'Company')}}</div>
                      <b-form-input
                        id="company"
                        type="text"
                        v-model.trim="customer.company"
                        :placeholder="getFieldLabel('company', 'Company')"
                        class="customer checkout-form-input"
                      ></b-form-input>
                      <div v-if="fieldErrors.company" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.company }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <label for="email" v-if="isIE">Email</label>
                    <b-form-group label="" label-for="email">
                      <div data-for="email" class="placeholder-label">Email</div>
                      <b-form-input id="email" type="text" v-model.trim="customer.email" placeholder="Email"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.email" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.email }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="phone" v-if="isIE">Phone</label>
                    <b-form-group label="" label-for="phone">
                      <div data-for="phone" class="placeholder-label">Phone</div>
                      <b-form-input id="phone" maxlength="12" type="tel" v-model.trim="customer.phone" placeholder="Phone"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.phone" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.phone }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <label for="address1" v-if="isIE">Address</label>
                    <b-form-group label="" label-for="address1">
                      <div data-for="address1" class="placeholder-label">Address</div>
                      <b-form-input id="address1" type="text" v-model.trim="customer.address1" placeholder="Street Address"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.address1" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.address1 }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="address2" v-if="isIE">Address 2</label>
                    <b-form-group label="" label-for="address2">
                      <div data-for="address2" class="placeholder-label">Address 2</div>
                      <b-form-input id="address2" type="text" v-model.trim="customer.address2" placeholder="Address 2"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.address2" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.address2 }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <label for="city" v-if="isIE">City</label>
                    <b-form-group label="" label-for="city">
                      <div data-for="city" class="placeholder-label">City</div>
                      <b-form-input id="city" type="text" v-model.trim="customer.city" placeholder="City"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.city" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.city }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="country" v-if="isIE">Country</label>
                    <b-form-group label="" label-for="country">
                      <div data-for="country" class="placeholder-label">Country</div>
                      <b-form-select id="country" v-model="customer.country" :options="countries" placeholder="Country" @change="countryChanged" class="customer select checkout-form-input"></b-form-select>
                      <div v-if="fieldErrors.country" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.country }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <div class="customer-match-formgroup">
                      <label for="state" v-if="isIE">State</label>
                      <b-form-group class="dropdown mb-0" label="" label-for="state">
                        <div data-for="state" class="placeholder-label">State</div>
                        <b-form-select v-if="isUsOrCA()" id="state" v-model="customer.state"
                                       :options="getStates()" placeholder="State" class="customer checkout-form-input"
                        ></b-form-select>
                        <b-form-input v-if="!isUsOrCA()" id="state" type="text"
                                      v-model.trim="customer.state" placeholder="State" class="customer checkout-form-input"
                        ></b-form-input>

                        <div v-if="fieldErrors.state" class="text-danger input-error text-right pr-1">
                          <small>{{ fieldErrors.state }}</small>
                        </div>
                      </b-form-group>
                    </div>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="zip" v-if="isIE">Zip Code</label>
                    <b-form-group label="" label-for="zip" class="mb-0">
                      <div data-for="zip" class="placeholder-label">Zip Code</div>
                      <b-form-input id="zip" :formatter="zipFormat()" type="text" v-model.trim="customer.zip" placeholder="Postal Code"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.zip" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.zip }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="checkout-card">
              <div class="shadow-sm p-3 bg-white rounded d-flex justify-content-between align-items-center">
                <p class="mb-0 card-heading">SHIPPING INFORMATION</p>
                <template v-if="isSessionUserKnown">
                  <a v-if="showShipEdit" class="checkout-change-button" @click="toggleEditing('ship')">Save</a>
                  <a v-else class="checkout-change-button" @click="toggleEditing('ship')">Edit</a>
                </template>
              </div>
              <div class="p-3" v-if="isSessionUserKnown && !showShipEdit">
                <div class="checkout-address-container">
                  <p class="checkout-text">{{customer.ship_first_name}} {{customer.ship_last_name}}
                  </p>
                  <p class="checkout-text mt-1">{{customer.ship_address1}}</p>
                  <p class="checkout-text mt-1">{{customer.ship_address2}}</p>
                  <p class="checkout-text mt-1">
                    {{customer.ship_city}}<template v-if="customer.ship_city">, </template>
                    {{customer.ship_state}}<template v-if="customer.ship_state">, </template>
                    {{customer.ship_country}}<template v-if="customer.ship_country">, </template>
                    {{customer.ship_zip}}
                  </p>
                  <p class="checkout-text mt-1">{{customer.email}}</p>
                  <p class="checkout-text mt-1">{{customer.phone}}</p>
                </div>
              </div>
              <div class="pb-0 px-3 pt-3" v-if="showShipEdit && !billShipSame">
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <label for="ship_first_name" v-if="isIE">First Name</label>
                    <b-form-group label="" label-for="ship_first_name">
                      <div data-for="ship_first_name" class="placeholder-label">First Name</div>
                      <b-form-input id="ship_first_name" type="text" v-model.trim="customer.ship_first_name" placeholder="First Name"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.ship_first_name" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.ship_first_name }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="ship_last_name" v-if="isIE">Last Name</label>
                    <b-form-group label="" label-for="ship_last_name">
                      <div data-for="ship_last_name" class="placeholder-label">Last Name</div>
                      <b-form-input id="ship_last_name" type="text" v-model.trim="customer.ship_last_name" placeholder="Last Name"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.ship_last_name" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.ship_last_name }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <label for="ship_address1" v-if="isIE">Address</label>
                    <b-form-group label="" label-for="ship_address1">
                      <div data-for="ship_address1" class="placeholder-label">Address</div>
                      <b-form-input id="ship_address1" type="text" v-model.trim="customer.ship_address1" placeholder="Street Address"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.ship_address1" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.ship_address1 }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="ship_address2" v-if="isIE">Address 2</label>
                    <b-form-group label="" label-for="ship_address2">
                      <div data-for="ship_address2" class="placeholder-label">Address 2</div>
                      <b-form-input id="ship_address2" type="text" v-model.trim="customer.ship_address2" placeholder="Street Address 2"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.ship_address2" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.ship_address2 }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="pr-0 col-pd">
                    <label for="ship_city" v-if="isIE">City</label>
                    <b-form-group label="" label-for="ship_city">
                      <div data-for="ship_city" class="placeholder-label">City</div>
                      <b-form-input id="ship_city" v-on:input="debounceInput" type="text" v-model.trim="customer.ship_city" placeholder="City"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.ship_city" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.ship_city }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="ship_country" v-if="isIE">Country</label>
                    <b-form-group label="" label-for="ship_country">
                      <div data-for="ship_country" class="placeholder-label">Country</div>
                      <b-form-select id="ship_country" v-model="customer.ship_country" :options="countries" placeholder="Country" @change="shipCountryChanged" class="customer select checkout-form-input"></b-form-select>
                      <div v-if="fieldErrors.ship_country" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.ship_country }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col class="pr-0 col-pd">
                <span class="customer-match-formgroup">
                  <label for="ship_state" v-if="isIE">State</label>
                  <b-form-group class="dropdown"  label="" label-for="ship_state">
                    <div data-for="ship_state" class="placeholder-label">State</div>
                    <b-form-select v-if="isUsOrCA(true)" id="ship_state" v-model="customer.ship_state"
                                   :options="getStates(true)" placeholder="State" class="customer checkout-form-input"
                    ></b-form-select>
                      <b-form-input v-if="!isUsOrCA(true)" id="state" type="text"
                                    v-model.trim="customer.ship_state" placeholder="State" class="customer checkout-form-input"
                      ></b-form-input>
                    <div v-if="fieldErrors.ship_state" class="text-danger input-error text-right pr-1">
                      <small>{{ fieldErrors.ship_state }}</small>
                    </div>
                  </b-form-group>
                </span>
                  </b-col>
                  <b-col class="col-pd-right">
                    <label for="ship_zip" v-if="isIE">Zip Code</label>
                    <b-form-group label="" label-for="ship_zip">
                      <div data-for="ship_zip" class="placeholder-label">Zip Code</div>
                      <b-form-input id="ship_zip" :formatter="zipFormat(true)" v-on:input="debounceInput" type="text" v-model.trim="customer.ship_zip" placeholder="Postal Code"
                                    class="customer checkout-form-input"></b-form-input>
                      <div v-if="fieldErrors.ship_zip" class="text-danger input-error text-right pr-1">
                        <small>{{ fieldErrors.ship_zip }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
              <div class="px-3 pb-1" :class="billShipSame && 'mt-3'" v-if="!isSessionUserKnown">
                <b-form-group label="" class="mb-0">
                  <b-form-checkbox
                    id="billShipSame"
                    class="billing-information"
                    v-model="billShipSame"
                    name="billShipSame"
                    :value="true"
                    :unchecked-value="false"
                  >
                    Shipping same as billing information
                  </b-form-checkbox>
                </b-form-group>
              </div>
            </div>
            <div class="checkout-card">
              <h6 class="shadow-sm p-3 bg-white rounded payment-method mb-0">PAYMENT METHOD</h6>
              <div class="payment-sources-container" v-if="isSessionUserKnown" :class="this.paymentSource && 'p-3'">
                <b-form-radio-group id="radio-group" name="radio-group checkout-radio-group" stacked v-model="orderPaymentSource">
                  <b-form-radio  class="existing-card-details shadow-sm rounded" :value="orderPaymentSourceOptions.Default" v-if="this.paymentSource">
                    <div class="payment-source-card-label d-flex">
                      <div>
                        <img class="footer-btn card-icon" :src="require(`@/assets/images/${(getCardIcon(this.paymentSource.type.toLowerCase()))}.svg`)"/>
                      </div>
                      <div class="ml-auto text-nowrap"> **** **** **** {{this.paymentSource.last4}}</div>
                    </div>
                  </b-form-radio>
                  <div class="mt-3 add-card" v-if="orderPaymentSource !== orderPaymentSourceOptions.New">
                    <input type="radio" name="radio-group checkout-radio-group" v-model="orderPaymentSource" autocomplete="off" class="custom-control-input" :value="orderPaymentSourceOptions.New" id="new-card">
                    <label for="new-card" class="py-2 px-3 rounded h-100 btn-new-card">
                      <span>&#xff0b; Add New Card</span>
                    </label>
                  </div>
                </b-form-radio-group>
              </div>
              <div class="px-3 pb-1 card-details" v-if="showSourceEdit" :class="(!this.paymentSource || orderPaymentSource !== orderPaymentSourceOptions.New) && 'pt-3'">
                <b-row>
                  <b-col class="customer-match-formgroup">
                    <b-form-group label="" label-for="title">
                      <b-input-group class="card-number" >
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <font-awesome-icon :icon="['far', 'user']" class="footer_btn"></font-awesome-icon>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input :maxlength="30" :data-error="(fieldErrors.title) ? true : false" ref="title" class="checkout-form-input" id="title" type="text" v-model="creditCard.title" placeholder="Name on Card"></b-form-input>
                      </b-input-group>
                      <div v-if="fieldErrors.title" class="text-danger input-error text-right pr-5">
                        <small class="px-1">{{ fieldErrors.title }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="">
                  <b-col class="customer-match-formgroup">
                    <b-form-group label="" label-for="number">
                      <b-input-group class="card-number" >
                        <b-input-group-prepend>
                          <b-input-group-text>
                            <font-awesome-icon :icon="cardBrandClass" class="footer_btn"></font-awesome-icon>
                          </b-input-group-text>
                        </b-input-group-prepend>
                        <b-form-input max id="number" type="tel" ref="number" class="checkout-form-input form-control border-right-0"
                                      :data-error="(fieldErrors.number) ? true : false"
                                      placeholder="Card Number" maxlength="19"
                                      v-model.trim="creditCard.number" v-cardformat:formatCardNumber>
                        </b-form-input>
                        <b-input-group-prepend class="input-icon">
                          <b-input-group-text>
                            <img id="safe-and-secure" :src="require('@/assets/images/lock.svg')"/>
                            <b-tooltip target="safe-and-secure" triggers="hover"   placement="top">
                              All payments are Safe and Secure
                            </b-tooltip>
                          </b-input-group-text>
                        </b-input-group-prepend>
                      </b-input-group>
                      <div v-if="fieldErrors.number" class="text-danger input-error text-right pr-5">
                        <small class="px-1">{{ fieldErrors.number }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="">
                  <b-col sm="4" class="customer-match-formgroup col-6 pr-0">
                    <b-form-group class="dropdown" label="" label-for="expiry_month">
                      <div data-for="expiry_month" class="placeholder-label">Expiry Month</div>
                      <b-form-select ref="expiry_month" id="expiry_month" v-model="creditCard.expiry_month" :options="month"
                                     placeholder="Expiry Month" class="customer checkout-form-input"></b-form-select>
                      <div v-if="fieldErrors.expiry" class="text-danger">
                        <small>{{ fieldErrors.expiry }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" class="customer-match-formgroup col-6 pr-sm-0">
                    <b-form-group class="dropdown" label="" label-for="expiry_year">
                      <div data-for="expiry_year" class="placeholder-label">Expire Year</div>
                      <b-form-select id="expiry_year" v-model="creditCard.expiry_year" :options="year"
                                     placeholder="Expiry Year" class="customer checkout-form-input"></b-form-select>
                      <div v-if="fieldErrors.expiry" class="text-danger">
                        <small>{{ fieldErrors.expiry }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                  <b-col sm="4" class="customer-match-formgroup cvc col-6">
                    <b-form-group label="" label-for="cvv_code">
                      <b-input-group>
                        <b-form-input class="border-right-0 checkout-form-input" id="cvv_code" ref="cvv_code" :data-error="(fieldErrors.cvv_code) ? true : false"
                                      placeholder="CVV" type="number" pattern="\d*"
                                      v-model.trim="creditCard.cvv" v-cardformat:formatCardCVC>
                        </b-form-input>
                        <b-input-group-prepend class="input-icon">
                          <b-input-group-text class="py-0">
                            <img id="help" :src="require('@/assets/images/help.svg')"/>
                            <b-tooltip target="help" triggers="hover"   placement="top">
                              3 or 4 Digits usually found on the back of your card
                            </b-tooltip>
                          </b-input-group-text>
                        </b-input-group-prepend>
                      </b-input-group>
                      <div v-if="fieldErrors.cvv_code" class="text-danger input-error text-right pr-4">
                        <small >{{ fieldErrors.cvv_code }}</small>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </div>
            </div>
            <b-row v-if="isSessionUserKnown && showTerms" class="justify-content-center mt-4 mb-2">
              <div class="policy-text text-center">
                By tapping Complete Order, you agree to our
                <b-link>Terms </b-link> and
                <b-link>Policies</b-link>. The
                <b-link> Merchant's terms</b-link> and
                <b-link> policies </b-link> will apply.
              </div>
            </b-row>
            <b-row>
              <b-col class="col-pd col-pd-right">
                <b-button id="checkout-submit-btn" @click="checkout()" class="complete-order btn-success btn-back" variant="primary">
                  COMPLETE MY ORDER
                  <span class="float-right pr-2">
                <font-awesome-icon :icon="['fas', 'arrow-right']"></font-awesome-icon>
                </span>
                </b-button>
              </b-col>
            </b-row>
            <b-row class="privacy-container mt-3">
              <b-col class="col-pd col-pd-right">
                <img :src="require('@/assets/images/Secure-Connection.svg')"/>
              </b-col>
            </b-row>
            <div v-if="showSatisfactionGuarantee" class="mt-5 d-flex border flex-column flex-sm-row d-lg-none align-items-center  py-2 px-3 icon-guarantee">
              <div class="logo"><img class="" :src="require('@/assets/images/icon-guarantee.png')" alt="THE SOLVPATH GUARANTEE"></div>
              <div class="gurantee-container py-3 text-white">
                <h5 class="text-nowrap satisfaction-text text-center text-sm-left">SATISFACTION GUARANTEE</h5>
                <div class="guarantee-text">
                  We are committed to delivering a satisfying experience for all our customers.
                  We are so confident that you will like your purchase, that if you are not completely satisfied,
                  we will give your money back within {{campaign.guarantee_days}} days of the purchase date (Minus Shipping and Handling).
                </div>
              </div>
            </div>
          </b-form>
        </b-col>
        <b-col class="d-lg-block d-none" cols="6">
          <div class="checkout-card px-5 py-4 checkout-order-summary">
            <div class="order-summary-text text-center text-uppercase">Order Summary</div>
            <div class="order-summary-height pt-lg-2">
              <table class="border-bottom">
                <tr class="border-bottom" v-for="(item, index) in updatedCart" :key="'cart-item-' + index.toString()">
                  <td>
                    <img class="my-3 product-img" :src="getImageUrl(item)" @error="setAltImg($event, item)" alt=""/>
                  </td>
                  <td class="cart-product-name-cell w-100 pl-3">
                    <div class="mt-3">
                      <div class="d-flex justify-content-between">
                        <span class="checkout-product-name" v-html="item.campaign_product.name"></span>
                        <div type="button" v-b-tooltip.hover title="Remove product from cart">
                          <font-awesome-icon class="mt-1" :style="{ color: 'rgb(255 63 63)' }"
                                             :icon="['fas', 'trash-alt']"
                                             @click="updateQuantity(index, 0, false)"
                          >
                          </font-awesome-icon>
                        </div>
                      </div>
                      <div v-if="item.variant" class="product-variants">
                        {{ getItemVariants(item) }}
                      </div>
                      <div class="cart-product-name-text">Qty: {{item.quantity}}</div>
                    </div>
                    <div class="quantity-toggle mt-2" :class="{'my-3': item.quantity < item.campaign_product.max_quantity}">
                      <div class="cart-quantity-wrapper">
                        <button :disabled="item.quantity === 1 || item.campaign_product.max_quantity === 1" class="cart-quantity-button" @click="updateQuantity(index, item.quantity-1, false)">&mdash;</button>
                        <input class="cart-quantity-input" oninput="this.value=parseInt(this.value)" step="1" type="number" min="1" :max="item.campaign_product.max_quantity || 10"
                               :value="item.quantity" @change="updateQuantity(index, $event)"
                               :disabled="item.campaign_product.max_quantity === 1"
                        />
                        <button :disabled="+item.quantity === +item.campaign_product.max_quantity" class="cart-quantity-button" @click="updateQuantity(index, item.quantity+1, false)">&#xff0b;</button>
                      </div>
                      <div class="checkout-product-price mr-1">{{getPrice(item) | currency(currency)}}</div>
                    </div>
                    <p v-if="item.quantity >= item.campaign_product.max_quantity" class="max-quantity mb-2">
                      <sup>*</sup>Maximum order limit of {{item.campaign_product.max_quantity}}
                    </p>
                  </td>
                </tr>
              </table>
            </div>
            <div class="product-prices">
              <div class="mt-4 d-flex justify-content-between">
                <div>Subtotal</div>
                <div >{{totalPrice | currency(currency)}}</div>
              </div>
              <div class="mt-1 d-flex justify-content-between">
                <div>Shipping fees</div>
                <div v-if="shipping && shipping.length && Number(shipping[0].price) > 0">{{shipping[0].price | currency(currency)}}</div>
                <div v-else>Free</div>
              </div>
              <div class="mt-1 border-bottom d-flex justify-content-between">
                <div class="mb-3">Taxes</div>
                <div>{{tax | currency(currency)}}</div>
              </div>
            </div>
            <div class="mt-3 d-flex justify-content-between">
              <div><strong class="text-nowrap grand-total">Grand Total</strong> (including tax)</div>
              <div class="text-right"><strong class="grand-total">{{totalPriceIncTax | currency(currency)}}</strong></div>
            </div>
          </div>
          <div v-if="showSatisfactionGuarantee" class="d-flex border align-items-center py-4 px-3 icon-guarantee">
            <div><img class="" :src="require('@/assets/images/icon-guarantee.png')" alt="THE SOLVPATH GUARANTEE"></div>
            <div class="px-4 py-3 text-white">
              <h5 class="satisfaction-text">SATISFACTION GUARANTEE</h5>
              <div class="guarantee-text text-justify">
                We are committed to delivering a satisfying experience for all our customers.
                We are so confident that you will like your purchase, that if you are not completely satisfied,
                we will give your money back within {{campaign.guarantee_days}} days of the purchase date (Minus Shipping and Handling).
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
  <div v-else>
    Nothing in cart
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import 'solvpath-microform'
import {
  getItemImageUrl,
  getExpDate,
  isTestCard,
  calculatePrice,
  getItemVariants,
  setFallbackImageUrl,
  formatZipField,
  getCountryStates,
  isCountryUSOrCA,
  updateRequiredFields,
  getCountries,
  getFieldLabel,
  isFieldRequired
} from '@/utils'
import {OrderPaymentOptions, PaymentSource, PaymentSourceStrings} from '@/constants'
import debounce from 'lodash/debounce'

export default {
  name: 'Checkout',
  props: {
    session: Object
  },
  data: function() {
    return {
      active: false,
      updatedCart: [],
      checkoutInput: null,
      open: true,
      customer: {
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        country: 'US',
        ship_address1: null,
        ship_address2: null,
        ship_city: null,
        ship_company: null,
        ship_country: 'US',
        ship_first_name: null,
        ship_last_name: null,
        ship_state: null,
        ship_zip: null
      },
      creditCard: {
        title: null,
        number: null,
        expiry: null,
        expiry_month: null,
        expiry_year: null,
        cvv: null
      },
      month: [
        {value: null, text: 'Expiry Month', disabled: true},
        {value: '01', text: '01'},
        {value: '02', text: '02'},
        {value: '03', text: '03'},
        {value: '04', text: '04'},
        {value: '05', text: '05'},
        {value: '06', text: '06'},
        {value: '07', text: '07'},
        {value: '08', text: '08'},
        {value: '09', text: '09'},
        {value: '10', text: '10'},
        {value: '11', text: '11'},
        {value: '12', text: '12'}
      ],
      cardBrand: null,
      fieldErrors: {},
      showShipEdit: true,
      showBillEdit: true,
      paymentSource: null,
      showSourceEdit: true,
      orderPaymentSource: OrderPaymentOptions.New,
      paymentSourceOptions: [],
      billShipSame: true,
      showTerms: false,
      orderPaymentSourceOptions: OrderPaymentOptions
    }
  },
  watch: {
    // Note: since CVC can be 3 OR 4 digits we don't watch it
    'creditCard.number': function(val) {
      let number = val.replace(/\s/g, '')
      if (number && number.length > 12) {
        if (this.$cardFormat.validateCardNumber(val) || isTestCard(val, this.session, this.customer)) {
          this.fieldErrors.number = null
        } else {
          this.fieldErrors.number = 'Invalid Credit Card Number.'
        }
      }
    },
    'creditCard.expiry': function(val) {
      if (this.$cardFormat.validateCardExpiry(val)) {
        this.fieldErrors.expiry = null
      } else {
        this.fieldErrors.expiry = 'Invalid Expiration Date.'
      }
    },
    'creditCard.expiry_month': function(val) {
      if (this.creditCard.expiry_year) {
        val = val + ' / ' + this.creditCard.expiry_year.toString().slice(2)
        if (this.$cardFormat.validateCardExpiry(val)) {
          this.fieldErrors.expiry = null
        } else {
          this.fieldErrors.expiry = 'Invalid Expiration Date.'
        }
      }
    },
    'creditCard.expiry_year': function(val) {
      if (this.creditCard.expiry_month) {
        val = this.creditCard.expiry_month + ' / ' + val.toString().slice(2)
        if (this.$cardFormat.validateCardExpiry(val)) {
          this.fieldErrors.expiry = null
        } else {
          this.fieldErrors.expiry = 'Invalid Expiration Date.'
        }
      }
    },
    'creditCard.title': function(val) {
      var letter = '[a-zA-Z][a-zA-Z ]+'
      if (val.match(letter)) {
        this.fieldErrors.title = null
      } else {
        this.fieldErrors.title = 'Invalid Name On Card'
      }
    },
    'creditCard.cvv': function(val) {
      if (val === '') {
        this.fieldErrors.cvv_code = 'Invalid CVV Code.'
      } else if (val.length >= 3) {
        this.fieldErrors.cvv_code = null
      }
    },
    'orderPaymentSource': function(val) {
      this.showSourceEdit = val === OrderPaymentOptions.New
    },
    'billShipSame': function(val) {
      this.updateShippingAddress(val)
    },
    'customer': {
      handler: function(val) {
        this.fieldErrors = {}
        if (this.billShipSame && !this.isSessionUserKnown) {
          this.updateShippingAddress(this.billShipSame)
        }
      },
      deep: true
    },
    'cart': function(val) {
      this.updatedCart = JSON.parse(JSON.stringify(val))
      if (val && !val.length) {
        if (this.session && !this.session.is_legacy) {
          this.$store.dispatch('home')
            .then(() => {
              if (this.$router.history.current.meta.requireRedirectForHome) {
                this.$router.replace({name: 'session'}) // If on faq details move to main page
              } else {
                this.$router.go(0) // refresh
              }
            })
        } else {
          this.$router.push({ name: 'products' })
        }
      }
    },
    '$store.state.checkoutErrors': function(errors) {
      if (errors && errors.length) {
        let errorFields = {}
        let shippingFields = [
          'ship_address1',
          'ship_city',
          'ship_first_name',
          'ship_last_name',
          'ship_state',
          'ship_zip'
        ]
        let billingFields = [
          'address1',
          'city',
          'state',
          'zip',
          'first_name',
          'last_name',
          'email',
          'phone'
        ]
        errors.forEach((error, index) => {
          Object.keys(error).forEach((field) => {
            if (field in this.fieldErrors) {
              const errorMessage = error[field] instanceof Array && error[field].length
                ? error[field].join(', ') : error[field]
              errorFields[field] = errorMessage
            }
            if (!this.isSessionUserKnown) {
              this.showBillEdit = billingFields.indexOf(field) > -1
              this.showShipEdit = shippingFields.indexOf(field) > -1
            }
          })
        })

        if (Object.keys(errorFields).length) {
          Object.assign(this.fieldErrors, errorFields)
        } else {
          this.$store.commit('error', errors)
        }
      }
    }
  },
  computed: {
    ...mapState(['cart', 'isIE', 'shipping', 'tax', 'checkoutErrors', 'campaign', 'gateway']),
    ...mapGetters(['isSessionUserKnown']),
    year: function() {
      let years = [
        {value: null, text: 'Expiry Year', disabled: true}
      ]
      let currentYear = new Date().getFullYear()
      for (let i = currentYear; i < currentYear + 20; i++) {
        years.push({value: i, text: i})
      }
      return years
    },
    totalPrice: function() {
      let total = 0

      if (this.cart && this.cart.length) {
        this.cart.forEach(item => {
          total += calculatePrice(item, this.session)
        })
      }

      return total.toFixed(2)
    },
    totalPriceIncTax: function() {
      let total = 0
      total = parseFloat(this.totalPrice) + parseFloat(this.tax)
      if (this.shipping && this.shipping.length) {
        total += parseFloat(this.shipping[0].price)
      }
      return total.toFixed(2)
    },
    cardBrandClass: function() {
      return this.getBrandClass(this.cardBrand)
    },
    isCustomerUpdated: function() {
      let updated = false
      for (const [key, value] of Object.entries(this.customer)) {
        if (value !== this.session.customer[key]) {
          updated = true
          break
        }
      }
      return updated
    },
    currency: function() {
      return (this.updatedCart && this.updatedCart.length) ? this.updatedCart[0].campaign_product.currency : 'USD'
    },
    countries() {
      return getCountries(this.session)
    },
    showSatisfactionGuarantee() {
      return this.campaign && this.campaign.guarantee_days > 0
    }
  },
  methods: {
    debounceInput: debounce(function(e) {
      this.$store.dispatch('set_cart', this.updatedCart)
    }, 300),
    debounceCartUpdate: debounce(function(e) {
      this.$store.dispatch('set_cart', this.updatedCart)
    }, 500),
    initializeMicroform() {
      window.solvpathMicroform({
        apiKey: this.gateway.public_key,
        submitId: 'checkout-submit-btn',
        cardFieldId: 'number',
        cvvFieldId: 'cvv_code',
        expiryMonthId: 'expiry_month',
        expiryYearId: 'expiry_year',
        submitMode: window.SolvpathSubmitMode.AUTO_INTERCEPT,
        errorModal: (message) => {
          this.fieldErrors = {
            ...this.fieldErrors,
            number: message
          }
          this.$store.commit('error', message)
        }
      })
    },
    getPrice: function(item) {
      let price = calculatePrice(item, this.session)
      if (price !== null || !isNaN(price) || price !== undefined) {
        return price.toFixed(2)
      }
      return '0'
    },
    getFieldLabel: function(field, defaultLabel, isShipping = false) {
      const country = isShipping ? this.customer.ship_country : this.customer.country
      return getFieldLabel(field, defaultLabel, country, isShipping)
    },
    isFieldRequired: function(field, isShipping = false) {
      const country = isShipping ? this.customer.ship_country : this.customer.country
      return isFieldRequired(field, country, isShipping)
    },
    getItemVariants: function(item) {
      return getItemVariants(item)
    },
    getImageUrl: function(item) {
      return getItemImageUrl(item, 'small')
    },
    setAltImg: function(event, item) {
      setFallbackImageUrl(event, item, 'small', true)
    },
    updateQuantity: function(index, event, isEvent = true) {
      let quantity = 0
      if (isEvent) {
        if (event.currentTarget.value && event.currentTarget.value.length > 0) {
          quantity = parseInt(event.currentTarget.value)
        }
      } else {
        quantity = event
      }
      if (quantity >= 0) {
        if (quantity <= this.updatedCart[index].campaign_product.max_quantity) {
          this.updatedCart[index].quantity = parseInt(quantity)
        } else {
          this.updatedCart[index].quantity = this.updatedCart[index].campaign_product.max_quantity
        }
      } else {
        this.updatedCart[index].quantity = 0
      }

      this.updatedCart = [...this.updatedCart]

      this.debounceCartUpdate()
    },
    validateShippingInformation: function() {
      let requiredFields = [
        'ship_address1',
        'ship_city',
        'ship_first_name',
        'ship_last_name',
        'ship_zip',
        'ship_country'
      ]

      updateRequiredFields(requiredFields, this.customer.ship_country, true)

      let valid = true
      let existingFieldsErrors = {...this.fieldErrors}
      requiredFields.forEach(field => {
        let value = this.customer[field]
        existingFieldsErrors[field] = null
        if (!value || value.length < 1) {
          existingFieldsErrors[field] = 'This field is required.'
          valid = false
        }
      })
      this.fieldErrors = existingFieldsErrors
      return valid
    },
    validateBillingInformation: function() {
      let requiredFields = [
        'address1',
        'city',
        'zip',
        'first_name',
        'last_name',
        'email',
        'phone',
        'country'
      ]

      updateRequiredFields(requiredFields, this.customer.country)

      let valid = true
      let existingFieldsErrors = {...this.fieldErrors}
      requiredFields.forEach(field => {
        let value = this.customer[field]
        existingFieldsErrors[field] = null
        if (!value || value.length < 1) {
          existingFieldsErrors[field] = 'This field is required.'
          valid = false
        }
      })
      this.fieldErrors = existingFieldsErrors
      return valid
    },
    validateCreditCardInfo: function() {
      let valid = true
      let existingFieldsErrors = {...this.fieldErrors}
      if (this.orderPaymentSource === OrderPaymentOptions.New) {
        // validate card number
        existingFieldsErrors.title = null
        if (this.creditCard.title === null || !this.creditCard.title.trim()) {
          existingFieldsErrors.title = 'Invalid Name On Card'
          valid = false
        }
        existingFieldsErrors.number = null
        if (!this.$cardFormat.validateCardNumber(this.creditCard.number) && !isTestCard(this.creditCard.number, this.session, this.customer)) {
          existingFieldsErrors.number = 'Invalid Credit Card Number.'
          valid = false
        }
        // validate card expiry
        existingFieldsErrors.expiry = null
        if (this.creditCard.expiry_month === null || this.creditCard.expiry_year === null || !this.$cardFormat.validateCardExpiry(this.creditCard.expiry_month + ' / ' + this.creditCard.expiry_year.toString().slice(2))) {
          existingFieldsErrors.expiry = 'Invalid Expiration Date.'
          valid = false
        }
        // validate card CVC
        existingFieldsErrors.cvv_code = null
        if (!this.$cardFormat.validateCardCVC(this.creditCard.cvv)) {
          existingFieldsErrors.cvv_code = 'Invalid CVV Code.'
          valid = false
        }
      }
      this.fieldErrors = existingFieldsErrors
      return valid
    },
    updateShippingAddress: function(val) {
      if (val) {
        const fields = [
          'address1',
          'address2',
          'city',
          'state',
          'zip',
          'first_name',
          'last_name',
          'country'
        ]
        fields.forEach(field => {
          this.customer[`ship_${field}`] = this.customer[field]
        })
      }
    },
    checkout: function() {
      let isShippingInfoValid = this.validateShippingInformation()
      let isBillingInfoValid = this.validateBillingInformation()
      let isCreditCardInfoValid = this.validateCreditCardInfo()
      if (!isShippingInfoValid) {
        this.showShipEdit = true
      }
      if (!isBillingInfoValid) {
        this.showBillEdit = true
      }
      if (!isShippingInfoValid || !isBillingInfoValid || !isCreditCardInfoValid) {
        return
      }
      let cartData = []

      this.cart.forEach(item => {
        let bundledVariants = null

        if (item.campaign_product.bundled_variants && item.campaign_product.bundled_variants.length) {
          bundledVariants = []

          item.campaign_product.bundled_variants.forEach(bundle => {
            bundledVariants.push({variant: bundle.variant.id, quantity: bundle.quantity})
          })
        }

        cartData.push({
          campaign_product: item.campaign_product.id,
          variant: item.variant ? item.variant.id : null,
          quantity: item.quantity,
          bundled_variants: bundledVariants
        })
      })

      let params = {
        items: cartData
      }
      if (this.isSessionUserKnown && this.isCustomerUpdated) {
        params.customer = this.customer
      } else if (!this.isSessionUserKnown) {
        params.customer = this.customer
      }
      if (this.orderPaymentSource === OrderPaymentOptions.New) {
        params.card = {
          title: this.creditCard.title,
          number: this.creditCard.number,
          exp_month: this.creditCard.expiry_month,
          exp_year: (this.creditCard.expiry_year || '').toString(),
          cvv_code: this.creditCard.cvv
        }
      }
      if (this.gateway) {
        params.gateway = this.gateway.id
      }
      this.$store.commit('clear_checkout_error')
      this.$emit('submit', this.checkoutInput, params)
    },
    goBack: function() {
      this.$emit('back')
    },
    getBrandClass: function(brand) {
      let cardBrandToClass = {
        'jcb': ['fab', 'cc-jcb'],
        'amex': ['fab', 'cc-amex'],
        'visa': ['fab', 'cc-visa'],
        'unknown': ['fas', 'credit-card'],
        'discover': ['fab', 'cc-discover'],
        'diners': ['fab', 'cc-diners-club'],
        'mastercard': ['fab', 'cc-mastercard']
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    },
    getCardIcon: function(brand) {
      let cardBrandToClass = {
        'jcb': 'jcb',
        'amex': 'amex',
        'visa': 'visa',
        'unknown': 'credit-card',
        'discover': 'discover',
        'diners': 'diners',
        'mastercard': 'mastercard'
      }
      brand = cardBrandToClass[brand] ? brand : 'unknown'
      return cardBrandToClass[brand]
    },
    toggleEditing(name) {
      switch (name) {
        case 'ship':
          if (this.showShipEdit && this.validateShippingInformation()) {
            this.showShipEdit = false
          } else if (!this.showShipEdit) {
            this.showShipEdit = true
          }
          break
        case 'bill':
          if (this.showBillEdit && this.validateBillingInformation()) {
            this.showBillEdit = false
          } else if (!this.showBillEdit) {
            this.showBillEdit = true
          }
          break
        case 'source':
          if (this.showSourceEdit && this.validateCreditCardInfo()) {
            this.showSourceEdit = false
          } else if (!this.showSourceEdit) {
            this.showSourceEdit = true
          }
          break
        default:
          return true
      }
    },
    getStates(isShip = false) {
      return getCountryStates(isShip ? this.customer.ship_country : this.customer.country)
    },
    countryChanged() {
      this.customer.state = ''
      this.customer.zip = ''
    },
    shipCountryChanged() {
      this.customer.ship_state = ''
      this.customer.ship_zip = ''
    },
    isUsOrCA(isShip = false) {
      return isCountryUSOrCA(isShip ? this.customer.ship_country : this.customer.country)
    },
    zipFormat(isShip = false) {
      return value => {
        return formatZipField(value, isShip ? this.customer.ship_country : this.customer.country)
      }
    }
  },
  beforeCreate() {
    this.$store.commit('set_cart_state', false)
  },
  created() {
    this.$store.commit('ready')
    this.updatedCart = JSON.parse(JSON.stringify(this.cart))
    this.checkoutInput = this.session.valid_inputs[0]
    if (this.isSessionUserKnown) {
      Object.keys(this.customer).forEach(key => {
        this.customer[key] = this.session.customer[key]

        if (key === 'country' || key === 'ship_country') {
          this.customer[key] = this.customer[key].toUpperCase()
        }
      })
      this.billShipSame = false
      this.showShipEdit = false
      this.showBillEdit = false
      this.showSourceEdit = false
      this.$store.commit('busy')
      this.$store.dispatch('get_payment_sources')
        .then(paymentSources => {
          this.paymentSource = null
          let source = (paymentSources || []).find((paymentSource) => paymentSource.is_default)
          if (!source && paymentSources.length >= 1) {
            source = paymentSources[0]
          }

          if (source) {
            this.orderPaymentSource = OrderPaymentOptions.Default
            this.paymentSource = {
              id: source.id,
              isDefault: source.is_default,
              canUpdate: source.can_update && (source.payment_source === PaymentSource.CreditCard),
              isCard: source.payment_source === PaymentSource.CreditCard,
              source: PaymentSourceStrings[source.payment_source],
              type: source.cc_type,
              last4: source.cc_last4,
              expDate: getExpDate(source.cc_exp_date)
            }
          } else {
            this.showSourceEdit = true
          }
          this.$store.commit('ready')
        })
        .catch(err => {
          this.$store.commit('critical_error', err)
        })
    }
  },
  mounted() {
    if (this.gateway) {
      this.initializeMicroform()
    }
  }
}
</script>

<style scoped lang="less">
.order-summary-sm {
  width: 100vw;
  position: relative;
  margin-left: -50vw;
  left: 50%;
  top:0;
  background: #F5F5F5 0% 0% no-repeat padding-box;
  color:#4D4D4D;
  border:#4D4D4D;
  outline: none;

  .order-summary-dropdown {
    svg {
      width: 1.3em;
      height: 1.3em;
    }
  }
}

.custom-control-input {
  &:checked {
    &~.custom-control-label {
      &::before {
        color: #FFFFFF !important;
        background-color: var(--theme_color) !important;
        border-color: var(--theme_color) !important;
      }
    }
  }
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: none !important;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .3s ease;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(10px);
  opacity: 0;
}

.checkout-order-summary {
  background-color: #F5F5F5;

  .product-img{
    width: 91px;
    img {
      vertical-align: unset;
    }
  }
  .order-summary-text {
    font: normal normal 500 20px Ubuntu;
    text-transform: uppercase;
  }
  .product-prices {
    color: var(--checkout_text_color);
  }
  .grand-total {
    font-size: 18px;
  }
}

.checkout-change-button {
  color: var(--theme_color) !important;
  float: right;
  cursor: pointer;
  font-size: 18px;
  text-transform: uppercase;
}

.payment-sources-container {
  .add-card {
    color: var(--checkout_text_color);
    span {
      font-size: 12px;
    }
  }
  .payment-source-card-label {
    font-size: 16px;
  }
}

.checkout-radio-group {
  display: inline-block;
}

.icon-guarantee {
  flex-direction: column;
  background-image: url("./../assets/images/icon-guarantee-bg.png");
  background-position: center;

  .guarantee-container {
    padding-left: 2rem;
    padding-right: 2rem;
  }
  .logo {
    display: flex;
    justify-content: center;
  }
  img {
    width: 50%;
  }
  h5 {
    text-align: center;
    font-size: 1rem;
  }
  .guarantee-text {
    font-size: 12px;
    text-align: left;
  }

  .satisfaction-text {
    font-size: 16px;
  }
}

@media only screen and (min-width: 576px) {
  .icon-guarantee {
    flex-direction: row;
    .guarantee-text {
      text-align: justify;
    }
  }
}

@media only screen and (min-width: 769px) {
  .icon-guarantee {
    .guarantee-container {
      padding-left: 3rem;
      padding-right: 3rem;
    }
  }
}

@media only screen and (min-width: 993px) {
  .icon-guarantee {
    img {
      width: 150px;
    }
    .guarantee-text {
      font-size: 0.7rem;
    }
    .satisfaction-text {
      font-size: 16px;
    }
  }
}
</style>
